/* Project Import will be here */
import { post, IRequest } from "./index";
/* Project Import will be here */

/* Get all distributors mapped with logged in retailer */
export const getAllMappedDistributorsApi = () => {
  const request: IRequest = { subUrl: `/Distributor/List` };
  return post(request);
};

/* Switch one distributor to another distributor */
export const switchDistributor = (data: any) => {
  const request: IRequest = { subUrl: `/Distributor/SwitchDistributor`, data };
  return post(request);
};